import { z } from 'zod'

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Invalid: Must be a valid email'),
  password: z.string().min(1, 'Please enter your password.'),
})

export type LoginFormData = z.infer<typeof loginSchema>
